import { currentState } from '../state';

export function setCollapsedProTips(value: boolean): void {
    const state = currentState();

    state.caResult?.groups?.forEach((g) => {
        g.areas?.forEach((a) => {
            a.collapsedProTips = value;
        });
        g.first = g.areas?.[0];
        g.last = g.areas?.[g.areas.length - 1];
    });
}
